<span aria-hidden="true"><mdb-icon tabindex="0" class="modal-close-icon" aria-label="Close" (click)="callback()" fas icon="times" role="button"></mdb-icon></span>
